import { render } from "./AddEditDocumentModalDialog.vue?vue&type=template&id=4827478d&scoped=true&ts=true&lang=pug"
import script from "./AddEditDocumentModalDialog.vue?vue&type=script&lang=ts"
export * from "./AddEditDocumentModalDialog.vue?vue&type=script&lang=ts"

import "./AddEditDocumentModalDialog.vue?vue&type=style&index=0&id=4827478d&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4827478d"]])

export default __exports__